module.exports = __webpack_public_path__ + "static/media/contact-member-icon-yellow.030227e6.svg";